// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"NavLink_text-gradient__3kEz5","link":"NavLink_link__5VFAH","active":"NavLink_active__1JDPF"};